import _extends from 'babel-runtime/helpers/extends';

import { Navbar, Sidebar, AppMain } from './components';
import { mapGetters } from 'vuex';

export default {
  name: 'UserLayout',
  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain
  },
  data: function data() {
    return {};
  },

  computed: _extends({}, mapGetters(['navActiveIndex'])),
  methods: {
    navClick: function navClick(index) {}
  }
};